import { render, staticRenderFns } from "./RealEstateLeafletMapOrtofoto.vue?vue&type=template&id=0b3c2496&shadow"
import script from "./RealEstateLeafletMapOrtofoto.vue?vue&type=script&lang=js&shadow"
export * from "./RealEstateLeafletMapOrtofoto.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./RealEstateLeafletMapOrtofoto.vue?vue&type=style&index=0&lang=css&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports